import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import url from 'query-string';
import { Copy, Loader } from 'elements';
import { Main, Wrapper } from 'components';
import { loginWithInstagram } from 'actions/session';

import styles from './instagramAuth.scss';

class InstagramAuth extends Component {
  componentDidMount () {
    const { loginWithInstagram, history } = this.props;
    const code = url.parse(window.location.search).code;

    loginWithInstagram(code, history);
  }
  render() {
    const { loginError } = this.props;

    return (
      <Wrapper>
        {loginError &&
          <Copy className={styles.error} type="error" color="white">Something went wrong, please try again</Copy>
        }
        <Main>
          <Copy className={styles.authenticating} color="black" type="title">
            Authenticating...
          </Copy>
          <Loader />
        </Main>
      </Wrapper>
    );
  }
}

const InstagramAuthWithRouter = withRouter(InstagramAuth);

export default connect(state => ({
  loginError: state.session.instagramLoginError,
}), { loginWithInstagram })(InstagramAuthWithRouter);



// WEBPACK FOOTER //
// ./src/pages/instagramAuth/instagramAuth.js